import data from "./theme.mjs";
//#region src/locales/fr/docs/index.ts
var docs_default = { theme: data };
//#endregion
export { docs_default as default };
